import React, { CSSProperties, Dispatch } from 'react'

type ActiveTab = 'create' | 'my_trainings'

interface TabSwitcherProps {
	styles?: CSSProperties
	activeTab: ActiveTab
	setActiveTab: Dispatch<React.SetStateAction<ActiveTab>>
}

const TabSwitcher: React.FC<TabSwitcherProps> = ({
	styles,
	activeTab,
	setActiveTab,
}) => {
	const activeIndex: number = activeTab === 'create' ? 0 : 1

	return (
		<div className="training-tab-container" style={styles}>
			<div
				className={`training-tab-slider ${activeIndex === 1 ? 'is-second' : ''}`}
			/>
			<button
				type="button"
				data-ui="training-tab"
				aria-pressed={activeTab === 'create'}
				className={`training-tab ${activeTab === 'create' ? 'is-active' : ''}`}
				onClick={() => setActiveTab('create')}
			>
				Упражнения
			</button>
			<button
				type="button"
				data-ui="training-tab"
				aria-pressed={activeTab === 'my_trainings'}
				className={`training-tab ${activeTab === 'my_trainings' ? 'is-active' : ''}`}
				onClick={() => setActiveTab('my_trainings')}
			>
				Мои тренировки
			</button>
		</div>
	)
}

export default TabSwitcher
